import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { value: String }

  copy() {
    navigator.clipboard.writeText(this.valueValue).then(() => {
      const icon = this.element.querySelector("i")
      if (icon) {
        icon.classList.replace("bi-clipboard", "bi-clipboard-check")
        setTimeout(() => icon.classList.replace("bi-clipboard-check", "bi-clipboard"), 1500)
      }
    })
  }
}
